import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MeService } from '@client/app/services/entities/me/me.service';
import { UserInterface } from '@monsido/ng2/modules/models/api/interfaces/user.interface';
import { privacy_terms } from '@monsido/core/constants/general.constant';

@Component({
    selector: 'privacy-dialog-modern',
    templateUrl: './privacy-dialog-modern.component.html',
    standalone: false,
})
export class PrivacyDialogModernComponent implements OnInit {
    terms = '';
    accept = false;
    saving = false;
    version = '';

    constructor (
        private readonly dialogRef: DynamicDialogRef,
        private readonly dialogConfig: DynamicDialogConfig,
        private readonly sanitizer: DomSanitizer,
        private readonly monEventService: MonEventService,
        private readonly meService: MeService,
    ) {}

    ngOnInit (): void {
        this.version = this.dialogConfig.data?.version ?? '';
        this.monEventService.run('actionTrigger', { action: 'accept-terms-dialog-show' });
        this.terms = this.sanitizer.sanitize(SecurityContext.HTML, privacy_terms) ?? '';
    }

    submit (): void {
        if (!this.accept) {
            return;
        }

        this.saving = true;
        this.meService.update({
            privacy_policy_version_accepted: this.version,
        } as Partial<UserInterface>)
            .then(() => {
                this.monEventService.run('actionTrigger', { action: 'accept-terms-dialog-accepted' });
                this.dialogRef.close();
            })
            .catch(() => {
                // Do nothing on error, just reset saving state
            })
            .finally(() => {
                this.saving = false;
            });
    }
}
